<template>
  <button
    class="flex flex-row items-center transition-colors font-medium inline-block"
    :class="{
      'text-gray-900 bg-gray-100 hover:bg-gray-200': !disabled && color === 'gray',
      'text-white bg-sky-600 hover:bg-sky-200': !disabled && color === 'blue',
      'text-gray-400 bg-gray-50 hover:bg-gray-100': disabled && color === 'gray',
      'text-white bg-sky-300 hover:bg-sky-200': disabled && color === 'blue',
      'px-2': size === 'sm',
      'py-2 px-3': size === 'md',
      'py-3 px-3': size === 'lg'
    }"
    :disabled="disabled || submitting"
    @click="onClick()">
    <div class="flex-grow">
      <slot></slot>
    </div>
    <div class="flex-none spinner-border animate-spin inline-block w-6 h-6 border-4 ml-2 rounded-full" role="status"
      v-if="submitting">
    </div>
  </button>
</template>

<script>
export default {
  props: {
    click: Function,
    disabled: Boolean,
    color: String,
    size: String,
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>
